<script>
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import { VueEditor } from 'vue2-editor'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import { updateTextsConnectOnboardingData } from '@/api/settings'
import { mapGetters } from 'vuex'

export default {
  components: {
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-submit-button': SubmitButton,
    VueEditor
  },

  mixins: [HandlesBackendValidationErrors],

  data: () => ({
    form: {
      item_connect_onboarding_text: ''
    },
    editorToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  }),

  computed: {
    ...mapGetters('settings', [
      'settings'
    ])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        this.$set(this.form, 'item_connect_onboarding_text', settings.item_connect_onboarding_text)
      }
    }
  },

  methods: {
    async onSubmit() {
      if (this.$wait.is('saving connect onboarding form')) {
        return
      }

      this.resetErrors()
      this.$wait.start('saving connect onboarding form')
      const [error] = await updateTextsConnectOnboardingData(this.form)
      this.$wait.end('saving connect onboarding form')

      if (error) {
        this.handleBackendValidationErrors(error)

        window.eventBus.$emit('mia-error', {
          error: ['Daten konnten nicht gespeichert werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert']
      })

      await this.$store.dispatch('settings/loadSettings')
    }
  }
}
</script>

<template>
  <div>
    <mia-form @submit="onSubmit">
      <template #default>
        <mia-form-section
          title="Connect Onboarding"
          description="Hier hinterlegen Sie den Text für das Connect Onboarding Formular."
        >
          <mia-form-section-grid>
            <div class="col-span-2 relative">
              <label
                for="connect-onboarding-text-wysiwyg"
                class="mb-1 mr-2 tracking-wider text-gray-800"
              >
                Connect Onboarding Text
              </label>
              <vue-editor
                id="connect-onboarding-text-wysiwyg"
                v-model="form.item_connect_onboarding_text"
                :editor-toolbar="editorToolbar"
                @input="clearErrors('item_connect_onboarding_text')"
              />
              <mia-fade-transition>
                <small
                  v-if="getErrors('item_connect_onboarding_text') && getErrors('item_connect_onboarding_text').length > 0"
                  class="absolute bottom-0 -mb-4 block leading-3 text-red-600"
                >
                  {{ getErrors('item_connect_onboarding_text')[0] }}
                </small>
              </mia-fade-transition>
            </div>
          </mia-form-section-grid>
        </mia-form-section>
      </template>

      <template #actions>
        <mia-submit-button
          size="small"
          :is-loading="$wait.is('saving connect onboarding form')"
        />
      </template>
    </mia-form>
  </div>
</template>
